import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash.isequal';

import FilterSearchForm from './Filter/search/searchForm';
import ModalTable from './ModalTable';
import { useDebounceEffect } from '../utils/hooks/useDebounceEffect';

const ModalTableCheckboxSearch = ({
  name,
  placeholder,
  value,
  searchTypeList = [],
  onSearch,
  isRefresh,
  tagBusinessUnityList,
  agentSelectedList = [],
  onConfirm,
  onChangeAgentSelectedList,
  open,
  take,
  ...props
}) => {
  const typeInitialState = searchTypeList && searchTypeList.length && searchTypeList[0].value;
  const [type, setType] = useState(typeInitialState);
  const [term, setTerm] = useState('');
  const [skip, setSkip] = useState(take);
  const [lastValue, setLastValue] = useState(value);
  const [isSearch, setIsSearch] = useState(false);

  useEffect(() => {
    if (!isEqual(lastValue, value)) {
      setType(typeInitialState);
      setTerm('');
      setLastValue(value);
    }
    setIsSearch(false);
  }, [
    value,
  ]);

  useEffect(() => {
    setType(typeInitialState);
    setTerm('');
    setLastValue('');
    setIsSearch(false);
  }, [
    isRefresh,
  ]);

  const handleChangeTypeRadio = (event) => {
    setType(event.target.value);
    setTerm('');
  };

  const handleChangeTerm = (event) => {
    setTerm(event.target.value);
  };

  const handleSearchSubmit = (skip) => {
    setSkip(skip);

    setIsSearch(true);
  };

  const handleOnConfirm = (checkedData) => {
    setTerm('');
    setType(typeInitialState);
    onChangeAgentSelectedList([]);
    onConfirm(checkedData);
  };
  
  useDebounceEffect(() => {
    if(open) {
      onSearch({
        type,
        term,
        skip: 0,
      });
    }
  }, 500, [type, term]);

  return (
    <ModalTable
      open={open}
      name={name}
      value={value}
      isSearch={isSearch}
      skip={skip}
      setSkip={setSkip}
      loadNextData={{
        type,
        term,
        skip,
      }}
      renderContentAbove={() => (
        <FilterSearchForm
          typeList={searchTypeList}
          placeholder={placeholder}
          name={name}
          value={{
            type,
            term,
          }}
          tagBusinessUnityList={tagBusinessUnityList}
          handleOutput={handleSearchSubmit}
          onChangeType={handleChangeTypeRadio}
          onChangeTerm={handleChangeTerm}
          skip={skip}
        />
      )}
      agentSelectedList={agentSelectedList}
      onConfirm={handleOnConfirm}
      onChangeAgentSelectedList={onChangeAgentSelectedList}
      take={take}
      {...props}
    />
  );
};

ModalTableCheckboxSearch.propTypes = {
  name: PropTypes.any.isRequired,
  placeholder: PropTypes.any,
  searchTypeList: PropTypes.array,
  value: PropTypes.array,
  onSearch: PropTypes.func,
  isRefresh: PropTypes.bool,
  ...ModalTable.propTypes,
};

ModalTableCheckboxSearch.defaultProps = {
  placeholder: '',
  searchTypeList: [],
  value: [],
  onSearch: () => { },
  isRefresh: false,
};

export default ModalTableCheckboxSearch;
